module.exports = '2.5.4';



// WEBPACK FOOTER //
// ./src/version.js